import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/service/auth.service';

// Capability-driven landing route for the Workforce-shell experience. Always
// returns a UrlTree, so it can guard a component-less route.
export const landingRedirectGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const orgId = auth.getSelectedOrgIdValue;
  if (!orgId) {
    return router.parseUrl('/invite');
  }

  const org = auth.getSelectedOrg();
  const settings: any = org?.settings;
  if (settings?.moneyball?.features?.workforce || settings?.chat?.capability) {
    return router.parseUrl('/chat');
  }
  if (auth.getOrgCapabilitesValue.includes('ledger')) {
    return router.parseUrl('/' + orgId + '/ledgers');
  }
  return router.parseUrl('/people');
};
